/* src/app/forms/produtos/amazon/amazon-error-message/amazon-error-message.component.scss */
.panel {
  display: flex;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid transparent;
  display: flex;
  flex-direction: column;
}
.panel-header {
  padding: 10px 15px;
  border-bottom: 1px solid transparent;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
.panel-body {
  padding: 15px;
}
.panel-danger {
  border-color: #ebccd1;
  color: #a94442;
  background-color: #f2dede;
  border-color: #ebccd1;
}
.error-dialog {
  margin: 20px;
}
:host {
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
}
/*# sourceMappingURL=amazon-error-message.component.css.map */
